// extracted by mini-css-extract-plugin
module.exports = {"black":"events-teaser-tile_black__qlCBh","dateList":"events-teaser-tile_dateList__OINI3","translationWrapper":"events-teaser-tile_translationWrapper__p74nh"};